module.exports = __webpack_public_path__ + "465b555fe44aa17f681a505f56af9cd6.png";